import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";

import {
    exclusiveOutisdeKeys,
    myAxios,
    outsideDailydefaultEmptyData,
    standbyWeeks,
    weeknum,
    MyDate,
} from "src/components/common/functions";

const allowedSearchKeys = ["category", "status", "q", "page", "limit"] as const;

export async function allDailyCallOutLoader({ params, request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if (!allowedSearchKeys.includes(key as typeof allowedSearchKeys[number])) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.has("category")) {
        url.searchParams.set("category", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("status")) {
        url.searchParams.set("status", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.has("q")) {
        url.searchParams.set("q", "");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "50");
        shouldRedirect = true;
    }

    const fallbackWeek = weeknum(new MyDate().s());
    const selectedWeek = params.week && standbyWeeks.includes(params.week) ? params.week : fallbackWeek;
    const rawDay = Number(params.day);
    const selectedDay = Number.isInteger(rawDay) && rawDay >= 0 && rawDay <= 6 ? rawDay : 0;
    if (params.week !== selectedWeek || String(params.day ?? "") !== String(selectedDay) || shouldRedirect) {
        throw redirect(`/AllDailyCallOut/${selectedWeek}/${selectedDay}?${url.searchParams.toString()}`);
    }

    const formData = new FormData();
    formData.append("week", selectedWeek);
    const res = await myAxios({ fileName: "outside/daily/allDaily.php", formData });
    if (!res) throw redirect("/");

    const forms = (res.data ?? []).map((personData: Record<string, string>) =>
        Object.fromEntries(
            Object.entries(personData).map(([key, value]) =>
                !exclusiveOutisdeKeys.includes(key)
                    ? [key, JSON.parse(value || outsideDailydefaultEmptyData)]
                    : [key, value]
            )
        )
    );

    return {
        forms,
        week: selectedWeek,
        day: selectedDay,
    };
}

export async function unlockAllDailyCallOutAction({ request }: ActionFunctionArgs) {
    const formData = await request.formData();
    const redirectTo = String(formData.get("redirectTo") ?? "/AllDailyCallOut");
    const res = await myAxios({
        fileName: "outside/daily/setDailyUnlock.php",
        formData,
    });
    if (!res) return null;
    throw redirect(redirectTo);
}
